(function () {
  'use strict';
  document.addEventListener('DOMContentLoaded', function () {
    const pdp = document.getElementById('PrintedPDP');
    if (!pdp) return;
    const sectionId = pdp.dataset.sectionId;
    const variantsEl = document.getElementById('ProductVariants-' + sectionId);
    if (!variantsEl) return;
    const variants = JSON.parse(variantsEl.textContent || '[]');
    const variantInput = document.getElementById('ProductVariantId-' + sectionId);
    const addToCartBtn = document.getElementById('AddToCart-' + sectionId);
    const atcLabel = addToCartBtn && addToCartBtn.querySelector('.printed-pdp__atc-label');
    const atcPrice = addToCartBtn && addToCartBtn.querySelector('.printed-pdp__atc-price');
    const sizeLabel = document.getElementById('SelectedSize-' + sectionId);
    const colorLabel = document.getElementById('SelectedColor-' + sectionId);
    const qtyInput = document.getElementById('Quantity-' + sectionId);
    const qtyMinus = document.getElementById('QtyMinus');
    const qtyPlus = document.getElementById('QtyPlus');
    const stickyATC = document.getElementById('StickyATC');
    const stickyATCBtn = document.getElementById('StickyATCBtn');
    const stickySize = document.getElementById('StickySelectedSize');
    const sizeGuideBtn = document.getElementById('SizeGuideBtn-' + sectionId);
    const sizeModal = document.getElementById('SizeGuideModal');
    const sizeModalClose = document.getElementById('SizeGuideClose');
    const sizeModalOverlay = document.getElementById('SizeGuideOverlay');

    function getSelectedOptions() {
      const opts = {};
      pdp.querySelectorAll('[data-option-index]').forEach(btn => {
        if (btn.classList.contains('is-selected')) {
          opts[parseInt(btn.dataset.optionIndex, 10)] = btn.dataset.optionValue;
        }
      });
      return opts;
    }

    function findVariant(selectedOpts) {
      return variants.find(v => v.options.every((optVal, i) => selectedOpts[i] === undefined || selectedOpts[i] === optVal)) || null;
    }

    function formatMoney(cents) {
      return '₹' + Math.floor(cents / 100).toLocaleString('en-IN');
    }

    function updateVariantUI(variant) {
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      const price = formatMoney(variant.price);
      if (atcPrice) atcPrice.textContent = '· ' + price;
      if (addToCartBtn) {
        if (variant.available) {
          addToCartBtn.disabled = false;
          addToCartBtn.removeAttribute('aria-disabled');
          if (atcLabel) atcLabel.textContent = 'Add to Cart';
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.setAttribute('aria-disabled', 'true');
          if (atcLabel) atcLabel.textContent = 'Sold Out';
          if (atcPrice) atcPrice.textContent = '';
        }
      }
      if (stickyATCBtn) {
        stickyATCBtn.disabled = !variant.available;
        stickyATCBtn.textContent = variant.available ? 'Add · ' + price : 'Sold Out';
      }
      const urgency = pdp.querySelector('.printed-pdp__urgency');
      if (urgency) {
        const show = variant.inventory_management === 'shopify' && variant.inventory_quantity <= 10 && variant.inventory_quantity > 0;
        urgency.hidden = !show;
        if (show) urgency.textContent = 'Only ' + variant.inventory_quantity + ' left — selling fast';
      }
    }

    pdp.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-option-value][data-option-index]');
      if (!btn || btn.classList.contains('is-unavailable')) return;
      const optionIndex = parseInt(btn.dataset.optionIndex, 10);
      const optionValue = btn.dataset.optionValue;
      pdp.querySelectorAll('[data-option-index="' + optionIndex + '"]').forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      if (btn.classList.contains('printed-pdp__size-btn')) {
        if (sizeLabel) sizeLabel.textContent = optionValue;
        if (stickySize) stickySize.textContent = optionValue;
      }
      if (btn.classList.contains('printed-pdp__color-btn') && colorLabel) colorLabel.textContent = optionValue;
      const variant = findVariant(getSelectedOptions());
      if (variant) updateVariantUI(variant);
    });

    const thumbs = pdp.querySelectorAll('.printed-pdp__thumb');
    const mainImages = pdp.querySelectorAll('.printed-pdp__main-image');
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', function () {
        thumbs.forEach(t => t.classList.remove('is-active'));
        this.classList.add('is-active');
        mainImages.forEach(img => {
          img.classList.remove('is-active');
          if (img.dataset.mediaId === this.dataset.mediaId) img.classList.add('is-active');
        });
      });
    });

    if (qtyMinus && qtyPlus && qtyInput) {
      qtyMinus.addEventListener('click', () => { const v = parseInt(qtyInput.value, 10); if (v > 1) qtyInput.value = v - 1; });
      qtyPlus.addEventListener('click', () => { qtyInput.value = parseInt(qtyInput.value, 10) + 1; });
    }

    function openModal() { if (!sizeModal) return; sizeModal.hidden = false; document.body.style.overflow = 'hidden'; }
    function closeModal() { if (!sizeModal) return; sizeModal.hidden = true; document.body.style.overflow = ''; if (sizeGuideBtn) sizeGuideBtn.focus(); }
    if (sizeGuideBtn) sizeGuideBtn.addEventListener('click', openModal);
    if (sizeModalClose) sizeModalClose.addEventListener('click', closeModal);
    if (sizeModalOverlay) sizeModalOverlay.addEventListener('click', closeModal);
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && sizeModal && !sizeModal.hidden) closeModal(); });

    if (stickyATC) {
      const atcBlock = document.querySelector('.printed-pdp__qty-atc');
      if (atcBlock) {
        new IntersectionObserver(entries => {
          entries.forEach(entry => {
            stickyATC.classList.toggle('is-visible', !entry.isIntersecting);
            stickyATC.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
          });
        }, { threshold: 0 }).observe(atcBlock);
      }
      if (stickyATCBtn) {
        stickyATCBtn.addEventListener('click', () => {
          const form = document.getElementById('printed-tee-form-' + sectionId);
          if (form) { form.querySelector('[name="quantity"]').value = qtyInput ? qtyInput.value : 1; form.requestSubmit ? form.requestSubmit() : form.submit(); }
        });
      }
    }

    const firstSelected = pdp.querySelector('.printed-pdp__size-btn.is-selected');
    if (firstSelected && stickySize) stickySize.textContent = firstSelected.dataset.optionValue;
  });
})();